import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'h-10 w-full rounded-lg bg-surface px-3 text-sm text-ink',
          'ring-1 ring-border-strong transition-shadow',
          'focus:outline-none focus:ring-2 focus:ring-brand',
          'disabled:cursor-not-allowed disabled:bg-sunken disabled:text-ink-muted',
          'aria-[invalid=true]:ring-critical',
          className,
        )}
        {...props}
      />
    )
  },
)
